import { INVOICES_BASE_URL } from 'shared/api/api';
import { invoiceApi } from '../api-slice';
import { purchaseApi } from 'entities/purchase/purchase.api';
import { AdvanceInvoiceDto, CopyInvoiceDto, CreateAdvanceInvoiceDto, CreateInvoiceDto, InvoiceDto, InvoiceInfoDto, SetInvoiceLegalEntityTaxDto } from '@sr/dto';
import { InvoiceLink } from '../invoice.hook';

const injectedApi = invoiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getInvoice: builder.query<InvoiceDto, number>({
      query: (id: number) => ({
        url: `${INVOICES_BASE_URL}/${id}`,
        method: 'GET',
      }),
    }),
    addInvoice: builder.mutation<InvoiceInfoDto, CreateInvoiceDto & InvoiceLink>({
      query: ({ purchaseId, companyId, ...dto }) => ({
        url: purchaseId ? `${INVOICES_BASE_URL}/for-purchase/${purchaseId}` : companyId ? `${INVOICES_BASE_URL}/for-company/${companyId}` : INVOICES_BASE_URL, // невозможный сценарий. вернет 404
        body: dto,
        method: 'POST',
      }),
      async onQueryStarted(query, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          if (query.purchaseId) {
            dispatch(purchaseApi.util.invalidateTags([{ type: 'purchases', id: query.purchaseId }]));
          }
        } catch (e) {
          console.error('RTK Query onQueryStarted error', e);
        }
      },
    }),
    copyInvoice: builder.mutation<CopyInvoiceDto, CopyInvoiceDto>({
      query: (dto: CopyInvoiceDto) => ({
        url: `${INVOICES_BASE_URL}/copy`,
        body: dto,
        method: 'POST',
      }),
    }),
    setInvoiceLegalEntityTax: builder.mutation<InvoiceDto, SetInvoiceLegalEntityTaxDto & { invoiceId: number }>({
      query: ({ invoiceId, legalEntityTax }) => ({
        url: `${INVOICES_BASE_URL}/set-tax/${invoiceId}/`,
        method: 'PATCH',
        body: { legalEntityTax },
      }),
    }),
    getAdvanceInvoice: builder.query<AdvanceInvoiceDto, number>({
      query: (id: number) => ({
        url: `${INVOICES_BASE_URL}/${id}/advance`,
        method: 'GET',
      }),
    }),
    addAdvanceInvoice: builder.mutation<AdvanceInvoiceDto, { invoiceId: number; dto: CreateAdvanceInvoiceDto }>({
      query: ({ invoiceId, dto }) => ({
        url: `${INVOICES_BASE_URL}/advance/for-invoice/${invoiceId}`,
        method: 'POST',
        body: dto,
      }),
    }),
    updateAdvanceInvoice: builder.mutation<AdvanceInvoiceDto, { invoiceId: number; id: number; dto: CreateAdvanceInvoiceDto }>({
    query: ({ invoiceId, id, dto }) => ({
      url: `${INVOICES_BASE_URL}/advance/${invoiceId}/${id}`,
      method: 'PATCH',
    body: dto,
    }),
  }),
  deleteAdvanceInvoice: builder.mutation<void, { invoiceId: number; id: number }>({
    query: ({ invoiceId, id }) => ({
      url: `${INVOICES_BASE_URL}/advance/${invoiceId}/${id}`,
      method: 'DELETE',
    }),
  }),
  }),
});

export const invoiceDataApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['invoice-data', 'advance-invoice-data'],
  endpoints: {
    getInvoice: {
      providesTags: (result, error, arg) => [{ type: 'invoice-data', id: arg }],
    },
    addInvoice: {
      invalidatesTags: (result, error, query) => (result ? [{ type: 'invoice-data', id: result.id }] : [{ type: 'invoice-data' }]),
    },
    copyInvoice: {
      invalidatesTags: (result, error, query) => (result ? [{ type: 'invoice-data', id: result.invoiceId }] : [{ type: 'invoice-data' }]),
    },
    setInvoiceLegalEntityTax: {
      invalidatesTags: (result, error, query) => (result ? [{ type: 'invoice-data', id: result.id }] : [{ type: 'invoice-data' }]),
    },
    getAdvanceInvoice: {
      providesTags: (result, error, arg) => [{ type: 'advance-invoice-data', id: arg }],
    },
    addAdvanceInvoice: {
      invalidatesTags: (result, error, { invoiceId }) => [
        { type: 'advance-invoice-data', id: invoiceId },
      ],
    },
    updateAdvanceInvoice: {
      invalidatesTags: (result, error, { invoiceId }) => [
        { type: 'advance-invoice-data', id: invoiceId },
      ],
    },
    deleteAdvanceInvoice: {
    invalidatesTags: (result, error, { invoiceId }) => [
      { type: 'advance-invoice-data', id: invoiceId },
    ],
    },
  },
});
